export default "__VITE_ASSET__uOvZlO6g__"